module.exports = __webpack_public_path__ + "img/BAU_Partners_11.56125358.jpg";